import React from 'react';
import classNames from 'classnames';
import { cellTypes } from '../enums';

const LeaderboardCellMoversTitle = ({ sorted, processingState }) => {
    const isActive = processingState.sortingType === cellTypes.MOVERS;
    const stateCss = classNames({
        'is-active': isActive,
        'is-top': isActive && processingState.isSortingAscending
    });

    return (
        <div
            className={`leaderboard__cell leaderboard__cell--title leaderboard__cell--movers ${stateCss}`}>
            <button
                className="leaderboard__cell-content-title"
                type="button"
                onClick={() => sorted(cellTypes.MOVERS)}
            >
                <div className="leaderboard__cell-title">
                    <div className="leaderboard__cell-title-sort">
                        <svg className="leaderboard__cell-title-icon-sort icon" width="9" height="6" focusable="false">
                            <use xlinkHref="#icon-triangle"></use>
                        </svg>
                        <svg className="leaderboard__cell-title-icon-sort icon" width="9" height="6" focusable="false">
                            <use xlinkHref="#icon-triangle"></use>
                        </svg>
                    </div>
                </div>
                <div className="leaderboard__cell-title-icon-wrapper">
                    <svg className="leaderboard__cell-title-icon icon" width="9" height="6" focusable="false">
                        <use xlinkHref="#icon-triangle"></use>
                    </svg>
                </div>
            </button>
        </div>
    );
};

export default LeaderboardCellMoversTitle;
